<template>
    <section class="gz-form">      
        <GZ-BlockTitle title="Строение" :bold="true"/>
        
        <section class="gz-add__building-block" @click.stop="accordion('addEditBuilding')">
            <div class="gz-add__building-info">
                <span class="icon-home-run gz-add__building-info__icon"></span>
                <div class="gz-add__building-info__info">
                    <span class="gz-add__building-info__type"><strong>Тип строения:&nbsp;</strong>{{ formData.type.value.name }}</span>
                    <div class="gz-add__building-info__address">
                        <span><strong>Адрес:&nbsp;</strong></span>
                        <span>{{ formData.settlementType.value }} {{ formData.city.value }}</span>
                        <span v-if="formData.street.value">,</span>
                        <span v-if="formData.street.value">&nbsp;{{ formData.street.value }}</span>
                        <span v-if="formData.number.value">,</span>
                        <span v-if="formData.number.value">&nbsp;д.{{ formData.number.value }}</span>
                    </div>
                </div>
            </div>
        </section> <!-- gz-add__building-block -->
            
        <section ref="addEditBuilding" class="gz-add__building">
            <div class="gz-add__building__inner">
                <gz-select-container
                    label="Тип строения"
                    class="gz-input-container_default gz-select_default"
                    :dataList="filterBuildingType"
                    :importedData="formData.type.value"
                    :required="true"
                    :valid="formData.type.valid"
                    :validationMessage="formData.type.validationMessage"
                    @selectedItem="formData.type.value = $event"   
                >
                    <GZ-TextInput
                        :importedData="formData.type.value.name"
                        :selectType="true"
                    />
                </gz-select-container>
                
                <gz-select-container
                    label="Юридическое лицо"
                    class="gz-input-container_default gz-select_default"
                    :dataList="serviceEntityList"
                    :importedData="formData.serviceEntity.value"
                    @selectedItem="formData.serviceEntity.value = $event"   
                >
                    <GZ-TextInput
                        :importedData="formData.serviceEntity.value.name"
                        :selectType="true"
                    />
                </gz-select-container>        

                <!-- <gz-input-container 
                    type="filter"
                    label="Юридическое лицо"
                    class="gz-input-container_default"    
                >
                    <vue-autosuggest
                        class="gz-text-input gz-vue-autosuggest"
                        :suggestions="suggestionResult"
                        :input-props="{id: 'service-entity', placeholder: 'Введите название юрлица'}"
                        @focus="suggestionResult = []"
                        @input="suggestions()"
                    >
                    </vue-autosuggest>
                </gz-input-container> -->

                <gz-input-container
                    label="Район"
                    class="gz-input-container_default"
                    :required="true"   
                    :valid="formData.district.valid"
                    :validationMessage="formData.district.validationMessage"
                >
                    <GZ-TextInput
                        :importedData="formData.district.value"
                        @value="formData.district.value = $event"
                    />
                </gz-input-container>
               
                <gz-select-container
                    label="Класс. нас. пунктов"
                    class="gz-input-container_default gz-select_default"
                    :dataList="settlementsTypesList"
                    :importedData="formData.settlementType.value"
                    @selectedItem="formData.settlementType.value = $event.name"  
                    :required="true"   
                    :valid="formData.settlementType.valid"
                    :validationMessage="formData.settlementType.validationMessage" 
                >
                    <GZ-TextInput
                        :importedData="formData.settlementType.value"
                        :selectType="true"
                    />
                </gz-select-container>
            
                <gz-input-container
                    label="Название нас.пункта"
                    class="gz-input-container_default"
                    :required="true"   
                    :valid="formData.city.valid"
                    :validationMessage="formData.city.validationMessage"
                >
                    <GZ-TextInput
                        :importedData="formData.city.value"
                        @value="formData.city.value = $event"
                    />
                </gz-input-container>
                
                <gz-select-container
                    label="Классификация улиц"
                    class="gz-input-container_default gz-select_default"
                    :dataList="locationTypeList"
                    :importedData="formData.streetType.value"
                    @selectedItem="formData.streetType.value = $event.name"  
                    :required="true"   
                    :valid="formData.streetType.valid"
                    :validationMessage="formData.streetType.validationMessage" 
                >
                    <GZ-TextInput
                        :importedData="formData.streetType.value"
                        :selectType="true"
                    />
                </gz-select-container>

                <gz-input-container
                    label="Улица"
                    class="gz-input-container_default"
                    :required="true"   
                    :valid="formData.street.valid"
                    :validationMessage="formData.street.validationMessage"
                >
                    <GZ-TextInput
                        :importedData="formData.street.value"
                        @value="formData.street.value = $event"
                    />
                </gz-input-container>
                
                <gz-input-container
                    label="Номер дома"
                    class="gz-input-container_default"
                    :required="true"   
                    :valid="formData.number.valid"
                    :validationMessage="formData.number.validationMessage"
                >
                    <GZ-TextInput
                        :importedData="formData.number.value"
                        @value="formData.number.value = $event"
                    />
                </gz-input-container>

                <gz-input-container
                    label="Этажность (только цифры)"
                    class="gz-input-container_default"
                    :valid="formData.levelNum.valid"
                    :validationMessage="formData.levelNum.validationMessage"
                >
                    <GZ-TextInput
                        type="number"
                        :importedData="formData.levelNum.value"
                        @value="formData.levelNum.value = $event"
                    />
                </gz-input-container>

                <gz-input-container
                    label="Кол-во подъездов (только цифры)"
                    class="gz-input-container_default"
                    :valid="formData.porchNum.valid"
                    :validationMessage="formData.porchNum.validationMessage"
                >
                    <GZ-TextInput
                        type="number"
                        :importedData="formData.porchNum.value"
                        @value="formData.porchNum.value = $event"
                    />
                </gz-input-container>
                  
                <!-- <section style="margin-bottom: 20px">
                    <span class="gz-option-select__item_title">Материал воздуховодов</span>
                        <div 
                            v-for="(item, index) in formData.constructionList"
                            :key="index" 
                            class="gz-option-select__item"
                        >
                            <GZ-OptionSelect
                                :value="item.name" 
                                :checked="item.selected ? true : false"
                                @update:select="formData.constructionList[index].selected = $event"
                            />
                        </div>
                </section>

                <section style="margin-bottom: 20px">
                    <span class="gz-option-select__item_title">Комментарий к материалу</span>
                    <div class="gz-textarea">
                        <textarea v-model="formData.constructionDescr" rows="5" style="width: 100%"></textarea>
                    </div>
                </section> -->

                <GZ-BlockTitle title="Дата следующей проверки"/>
                
                 <gz-input-container 
                    label="Укажите дату"
                    class="gz-filter__item display-iblock w-auto"    
                >
                    <GZ-DateInput 
                        @dateValue="formData.nextCheckupDate.value = $event" 
                        :value="formData.nextCheckupDate.value"
                        class="gz-date-input_no-border gz-date-input_calend-up"
                    />
                </gz-input-container>
                
                <div class="gz-block-controls">
                    <GZ-BaseButton 
                        :value="$route.params.id ? 'внести изменения' : 'сохранить строение'" 
                        icon="icon-floppy-disk"
                        class="gz-button_default gz-button_save-address"
                        :loading="loading"
                        @click="$route.params.id ? editBuildingInit() : saveBuildingInit()"
                    />
                </div>
            </div>
        </section> <!-- gz-add__building -->
        
        <!-- Помещения -->
        <section v-if="buildingSaved">
            <GZ-BlockTitle title="Помещения" :bold="true"/>

            
            <section v-if="addedShelters.length" class="gz-section-tp">
                <Shelter 
                    v-for="(item, index) in addedShelters"
                    :key="index"
                    :counter="index+1"
                    :items="item"
                    @delete="deleteShelter(index)"
                ></Shelter>
            </section>

        <GZ-BaseButton 
            value="добавить помещение" 
            icon="icon-plus"
            class="gz-button_default"
            @click="addShelter"
        />
        </section>
    </section>
</template>

<script>
import Shelter from './Shelter'

export default {
    name: 'AdminAddAddressForm',

    components: {
        Shelter
    },
    data() {
        return {
            formData: {
                type: {
                    value: {name: '', value: ''},
                    valid: true,
                    validationMessage: ''
                },
                serviceEntity: {
                    value: {id: '', name: ''},
                    list: []
                },
                country: {
                    value: 'Россия',
                    valid: true,
                    validationMessage: ''
                },
                region: {
                    value: 'Республика Крым',
                    valid: true,
                    validationMessage: ''
                },
                district: {
                    value: 'Симферопольский',
                    valid: true,
                    validationMessage: ''
                },
                settlementType: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                city: {
                    value: 'Симферополь',
                    valid: true,
                    validationMessage: ''
                },
                streetType: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                street: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                number: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                levelNum: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                porchNum: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                constructionList: [],
                constructionDescr: '',
                nextCheckupDate: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                test: null  
            },

            status: 'ACTIVE',

            shelters: [], //Создаваемые новые и Получаемые от сервера

            suggestionResult: [],

            validationMessages: {
                isEmpty: 'Обязательно для заполнения',
                formHasErrors: 'Форма содержит ошибки'
            },

            loading: false,
            buildingSaved: this.$route.params.id || false,

            counter: 0
        }
    },
    computed: {
        adminBuildingsTypes() {
            return this.$store.getters['adminBuildingsTypes']
        },
        addedShelters() {
            return this.shelters
        },
        filterBuildingType() {
            return this.$store.getters['filterBuildingType']
        },
        buldingSavedComputed() {
            return this.buildingSaved
        },
        serviceEntityList() {
            return this.formData.serviceEntity.list
        },
        locationTypeList() {
            return this.$store.getters['filterLocationTypes'] 
        },
        settlementsTypesList() {
            return this.$store.getters['filterSettlementsTypes'] 
        }
    },
    mounted() {    
        if (this.$route.params.id) {
        //Если просмотр уже созданного здания (редактирование)
            this.$store.dispatch('addressesGetBuilding', this.$route.params.id)
                .then(() => {
                    const buildingData = this.$store.getters['addressesBuilding'].attributes
                    this.formData.type.value = {
                        value: buildingData.type,
                        name: this.enumFilterMap('get', buildingData.type, this.$store.getters['filterBuildingType'])
                    },                 
                    
                    this.formData.country.value = buildingData.country
                    this.formData.region.value = buildingData.region
                    this.formData.settlementType.value = buildingData.citytype
                    this.formData.city.value = buildingData.city
                    this.formData.street.value = buildingData.street
                    this.formData.number.value = buildingData.number
                    this.formData.levelNum.value = buildingData.levelNum
                    this.formData.porchNum.value = buildingData.porchNum
                    this.formData.streetType.value = buildingData.streettype

                    //Рисуем список чекбоксов с материалами. Создаем независимую копию объекта
                    this.formData.constructionList = JSON.parse(JSON.stringify(this.$store.getters['filtersBuildingMaterial']))
                    
                    this.formData.constructionList.forEach((item_1, index) => {
                        //Полученное значение совпадает с текущим в цикле - отмечаем selected как true
                        buildingData.construction.forEach(item_2 => {
                            if (item_1.value === item_2) {
                                item_1.selected = true
                            }
                        })
                    })

                    this.formData.constructionDescr = buildingData.constructionDescr

                    this.formData.nextCheckupDate.value = buildingData.nextCheckupDate

                    return buildingData.seid
                })
                .then(response => {
                    //Список юр лиц и сохраненное юр лицо
                    this.$store.dispatch('serviceEntitiesGet')
                        .then(() => {
                            const data = this.$store.getters['serviceEntitiesList']

                            data.forEach(item => {
                                this.formData.serviceEntity.list.push({id: item.id, name: item.attributes.name})
                            })
                            
                            this.serviceEntityList.forEach(item => {
                                if (item.id === response) {
                                    this.formData.serviceEntity.value.id = item.id
                                    this.formData.serviceEntity.value.name = item.name
                                }
                            })
                        })
                })
                .then(() => {
                    this.$store.dispatch('addressesGetShelters', this.$route.params.id)
                        .then(() => {
                            this.shelters = this.$store.getters['addressesShelters']
                        })
                })
                .catch(err => {
                    console.error('Ошибка при загрузке данных здания: ', err)
                })
        }

        if (!this.$route.params.id) {
        //Если здание создается впервые
            this.$store.dispatch('serviceEntitiesGet')
                .then(() => {
                    const data = this.$store.getters['serviceEntitiesList']
                    data.forEach(item => {
                        this.formData.serviceEntity.list.push({id: item.id, name: item.attributes.name})
                    })

                    //Рисуем список чекбоксов с материалами. Создаем независимую копию объекта
                    this.formData.constructionList = JSON.parse(JSON.stringify(this.$store.getters['filtersBuildingMaterial']))
                })
                .then(() => {
                    this.accordion('addEditBuilding')
                })
        }
    },
    methods: {
        addShelter() {
            this.counter++
            this.shelters.push(this.counter)
        },
        deleteShelter(index) {
        //Удаляет созданные клиентом, но еще не сохраненные блоки - помещения
            this.shelters.splice(index, 1)
        },
        saveBuildingInit() {
            if (this.validation()) {
                this.saveBuilding()
            }
        },
        editBuildingInit() {
            if (this.validation()) {
                this.editBuilding(this.$route.params.id)
            }
        },
        validation() {
            const data = this.formData
            const message = this.validationMessages

            let errors = 0
            //Empty fields

            //** Тип */
            //Не пустое
            if (!this.isEmpty(data.type.value.value)) {
                this.formValidationUtil(data.type, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(data.type, true, '')
            }

            //District
            if (!this.isEmpty(data.district.value.value)) {
                this.formValidationUtil(data.district, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(data.district, true, '')
            }

            //City Class
            if (!this.isEmpty(data.settlementType.value)) {
                this.formValidationUtil(data.settlementType, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(data.settlementType, true, '')
            }

            //City
            if (!this.isEmpty(data.city.value)) {
                this.formValidationUtil(data.city, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(data.city, true, '')
            }
           
            //Street Class
            if (!this.isEmpty(data.streetType.value)) {
                this.formValidationUtil(data.streetType, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(data.streetType, true, '')
            }

            //Street
            if (!this.isEmpty(data.street.value)) {
                this.formValidationUtil(data.street, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(data.street, true, '')
            }

            //Number
            if (!this.isEmpty(data.number.value)) {
                this.formValidationUtil(data.number, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(data.number, true, '')
            }

            //Notification
            return this.validationNotification(errors)
        },
        setAttributes() {
            let construction = []
            this.formData.constructionList.forEach(item => {
                if (item.selected === true) {
                    construction.push(item.value)
                }
            })

            const attributes = {
                status: this.status,
                type: this.formData.type.value.value,
                seid: this.formData.serviceEntity.value.id,
                country: this.formData.country.value,
                region: this.formData.region.value,
                district: this.formData.district.value,
                citytype: this.formData.settlementType.value,
                city: this.formData.city.value,
                street: this.formData.street.value,
                streettype: this.formData.streetType.value,
                number: this.formData.number.value,
                levelNum: this.formData.levelNum.value,
                porchNum: this.formData.porchNum.value,
                construction: construction,
                constructionDescr: this.formData.constructionDescr,
                nextCheckupDate: this.formData.nextCheckupDate.value
            }

            return attributes
        },
        saveBuilding() {
        let iso_date = ''
        if (this.formData.nextCheckupDate.value) {
            iso_date = this.formData.nextCheckupDate.value.toISOString().split('.')[0]
        }
        
        this.$axios.post('building', {
            data: {
                type: 'building',
                attributes: this.setAttributes()
            }
        }, this.loading = true)
            .then(response => {
                setTimeout(() => {
                    this.loading = false
                    this.$store.dispatch('modalNotificationMessageOpen', ['Адрес сохранен'])
                    this.$router.push('address/' + response.data.data.id + '/edit')
                }, 1000)
            })
            .catch(err => {
                console.log('Ошибка добавления здания: ', err.response)
            })
        },
        editBuilding(id) {
            this.$axios.patch('building/' + id, {
                data: {
                    type: 'building',
                    id: id,
                    attributes: this.setAttributes()
                }
            }, this.loading = true)
            .then(response => {
                setTimeout(() => {
                    this.loading = false
                    this.$store.dispatch('modalNotificationMessageOpen', ['Адрес изменен'])
                }, 1000)
            })
            .catch(err => {
                console.log('Ошибка редактирования данных здания: ', err.response)
                this.loading = false
                this.$store.dispatch('modalNotificationMessageOpen', ['Ошибка редактирования данных здания'])
            })
        },
        suggestions() {
            let input = event.target.value
            
            if (input.length >= 2) {
                setTimeout(() => {
                    this.$axios({
                        method: 'GET',
                        url: 'svcentity',
                        params: {
                            pg: 0,
                            batch: 10
                        }
                    })
                    .then(response => {
                        this.suggestionResult = []
                    })
                }, 1000)
            }

            if (input.length < 2) {
                this.suggestionResult = []
            }
        }
    }
}
</script>